import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styles from "./paymentlist.module.css";
import { Check, CreditCard, FileMinus, X } from "react-feather";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useState } from "react";
import { TableLoader } from "../../../../../../../components/LoaderC";
import BillCard from "./BillCard";
import AppliedCreditCard from "./CreditCard";
import RecordPayment from "./RecordPayment";
import OnlinePayment from "./OnlinePayment";

const PaymentCard = ({ item, setLoading, setSnackbarOpen, setSnackbarMsg, setAddBillModalShow, setAddCreditModalShow, setAddPaymentModalShow, setIsUpdate, setEditId, setDeleteModalShow, setDeleteId, setDeleteType }) => {
    const [taskExpanded, setTaskExpanded] = useState("");

    const handleChange = (panel) => (event, isTaskExpanded) => {
        setTaskExpanded(isTaskExpanded ? panel : false);
    }

    return (<>
        <div className={`${styles.MonthDivider}`}>
            <span className={`${styles.MonthLabel}`}>{item?.month}</span>
            <div className={`${styles.MonthLine}`}></div>
            <span className={`${styles.MonthSum}`}>Billed {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.total_billed)} &nbsp;·&nbsp; Collected {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.total_collected)}</span>
        </div>
        {item?.transactions?.map((subItem, index) => {
            return <>

                {subItem?.type === 1 && <BillCard item={subItem} index={index} taskExpanded={taskExpanded} handleChange={handleChange.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setAddBillModalShow={setAddBillModalShow.bind(this)} setIsUpdate={setIsUpdate.bind(this)} setEditId={setEditId.bind(this)} setDeleteModalShow={setDeleteModalShow.bind(this)} setDeleteId={setDeleteId.bind(this)} setDeleteType={setDeleteType.bind(this)} />}

                {subItem?.type === 2 && subItem?.payment_type === "add-credit" && <AppliedCreditCard item={subItem} index={index} taskExpanded={taskExpanded} handleChange={handleChange.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setAddCreditModalShow={setAddCreditModalShow.bind(this)} setIsUpdate={setIsUpdate.bind(this)} setEditId={setEditId.bind(this)} setDeleteModalShow={setDeleteModalShow.bind(this)} setDeleteId={setDeleteId.bind(this)} setDeleteType={setDeleteType.bind(this)} />}

                {subItem?.type === 2 && subItem?.payment_type === "record-payment" && <RecordPayment item={subItem} index={index} taskExpanded={taskExpanded} handleChange={handleChange.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setAddPaymentModalShow={setAddPaymentModalShow.bind(this)} setIsUpdate={setIsUpdate.bind(this)} setEditId={setEditId.bind(this)} setDeleteModalShow={setDeleteModalShow.bind(this)} setDeleteId={setDeleteId.bind(this)} setDeleteType={setDeleteType.bind(this)} />}

                {subItem?.type === 2 && subItem?.payment_type === "online-payment" && <OnlinePayment item={subItem} index={index} taskExpanded={taskExpanded} handleChange={handleChange.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setAddPaymentModalShow={setAddPaymentModalShow.bind(this)} setIsUpdate={setIsUpdate.bind(this)} setEditId={setEditId.bind(this)} setDeleteModalShow={setDeleteModalShow.bind(this)} setDeleteId={setDeleteId.bind(this)} setDeleteType={setDeleteType.bind(this)} />}
            </>

            {/*<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                    <div className={`${styles.NotesCard}`}>
                        <div className={`${styles.RentRollDateSec} ${styles.Green}`}>
                            <div className={`${styles.RentRollDate}`}>Apr 11</div>
                            <div className={`${styles.RentRollYear}`}>2026</div>
                        </div>
                        <div className={`${styles.RentRollDesc} ${styles.Green}`}>
                            <div className={`${styles.Top}`}>
                                <div className={`${styles.Badge}`}><CreditCard /></div>
                                <div className={`${styles.Title}`}>Remaining balance</div>
                            </div>
                            <div className={`${styles.SubText}`}>Payment sent</div>
                        </div>
                        <div className={`${styles.RentRollDue}`}>
                            <div className={`${styles.DueEmpty}`}>—</div>
                        </div>
                        <div className={`${styles.RentRollPayment}`}>
                            <div className={`${styles.PaymentOk}`}>
                                <div className={`${styles.Label}`}><Check /> Collected</div>
                                <div className={`${styles.Amount}`}>$250.00</div>
                            </div>
                        </div>
                        <div className={`${styles.RentRollBalance}`}>
                            <div className={`${styles.BalanceZero}`}>
                                <div className={`${styles.Label}`}>Cleared</div>
                                <div className={`${styles.Amount}`}>$0.00</div>
                            </div>
                        </div>
                    </div>
                </AccordionSummary>
                <AccordionDetails className={`${styles.CussAccoRow}`}>
                    <div className={`${styles.RentRollExpandSec}`}>
                        <div className={`${styles.DetailsSec}`}>
                            <div className={`${styles.DetailsGrid}`}>
                                <div className={`${styles.DetailsCell}`}>
                                    <div className={`${styles.Label}`}>Payer</div>
                                    <div className={`${styles.Text}`}>Kimora Love</div>
                                </div>
                                <div className={`${styles.DetailsCell}`}>
                                    <div className={`${styles.Label}`}>Memo</div>
                                    <div className={`${styles.Text}`}>Remaining balance</div>
                                </div>
                                <div className={`${styles.DetailsCell}`}>
                                    <div className={`${styles.Label}`}>Amount</div>
                                    <div className={`${styles.Text}`}>$250.00</div>
                                </div>
                                <div className={`${styles.DetailsCell}`}>
                                    <div className={`${styles.Label}`}>Type</div>
                                    <div className={`${styles.Text}`}>One Time</div>
                                </div>
                                <div className={`${styles.DetailsCell}`}>
                                    <div className={`${styles.Label}`}>Status</div>
                                    <div className={`${styles.Text}`}>Completed</div>
                                </div>
                                <div className={`${styles.DetailsCell}`}>
                                    <div className={`${styles.Label}`}>Sent On</div>
                                    <div className={`${styles.Text}`}>Apr 11, 2026</div>
                                </div>
                                <div className={`${styles.DetailsCell}`}>
                                    <div className={`${styles.Label}`}>Method</div>
                                    <div className={`${styles.Text}`}>Cash App Pay</div>
                                </div>
                                <div className={`${styles.DetailsCell}`}>
                                    <div className={`${styles.Label}`}>Deposit Date</div>
                                    <div className={`${styles.Text}`}>Apr 11, 2026</div>
                                </div>
                                <div className={`${styles.DetailsCell}`}>
                                    <div className={`${styles.Label}`}>Account</div>
                                    <div className={`${styles.Text}`}>ZuJiKOOPVA</div>
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.ButtonSec}`}>
                            <button className={`${styles.Button} ${styles.Blue}`}>Resend Receipt</button>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion >*/}
        })}

    </>);
}

export default PaymentCard;